import React from 'react';
import { Button, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { MobileDesktopSetupNotice } from './MobileDesktopSetupNotice';
import { postPurchaseBi } from '../postPurchaseBi';
import { buildDashboardActionUrl, SETUP_VIDEO_DASHBOARD_PATH, SETUP_VIDEO_EMBED_URL } from '../helpers';
import { SetupVideoIcon } from './icons';
import { EmbeddedVideoPlayer } from './EmbeddedVideoPlayer';
import styles from '../PostPurchaseStep.scss';

interface SetupPanelProps {
  isAcceptPaymentsSetup: boolean;
  isMobile: boolean;
  metaSiteId: string | null;
}

export function SetupPanel({ isAcceptPaymentsSetup, isMobile, metaSiteId }: SetupPanelProps) {
  const { t } = useTranslation();
  const actionUrl = buildDashboardActionUrl(metaSiteId, SETUP_VIDEO_DASHBOARD_PATH);

  return (
    <section
      className={`${styles.postPurchasePanel} ${styles.postPurchaseSetupPanel}`}
      aria-label={t('post_purchase.setup.video_aria')}
    >
      <div className={styles.postPurchaseSetupGrid}>
        <article className={styles.postPurchaseSetupVideo}>
          <div className={styles.postPurchaseSetupCopy}>
            <SetupVideoIcon />
            <Heading as="h2" size="medium">
              {t('post_purchase.setup.title')}
            </Heading>
            <Text size="small" secondary className={styles.postPurchaseSetupDescription}>
              {isAcceptPaymentsSetup ? t('post_purchase.setup.done_description') : t('post_purchase.setup.description')}
            </Text>
            {!isAcceptPaymentsSetup &&
              (isMobile ? (
                <MobileDesktopSetupNotice />
              ) : (
                <Button
                  as="a"
                  href={actionUrl || '#'}
                  aria-disabled={!actionUrl}
                  onClick={(event) => {
                    if (!actionUrl) {
                      event.preventDefault();
                      return;
                    }

                    postPurchaseBi.connectPayments();
                  }}
                  priority="primary"
                  size="medium"
                  skin="standard"
                >
                  {t('post_purchase.setup.cta')}
                </Button>
              ))}
          </div>
          <div className={styles.postPurchaseSetupMedia}>
            <EmbeddedVideoPlayer src={SETUP_VIDEO_EMBED_URL} title={t('post_purchase.setup.title')} />
          </div>
        </article>
      </div>
    </section>
  );
}
